var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8164,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F9E1FA",
    stroke: "#D358D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.589 16.182C10.288 16.182 8.988 14.895 8.988 12.568V6.965H10.093V12.581C10.093 14.297 10.964 15.207 12.589 15.207C14.214 15.207 15.098 14.284 15.098 12.581V6.965H16.203V12.568C16.203 14.895 14.929 16.182 12.589 16.182Z",
    fill: "#BF0BC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterU);
export default __webpack_public_path__ + "static/media/letterU.8c6f4db07bd344111bd5678a90598893.svg";
export { ForwardRef as ReactComponent };